import { For, Show } from "solid-js";
import { MEETUP_CITIES } from "~/lib/meetup";

type Props = {
  value: string;
  disabled?: boolean;
  hint?: string;
  onChange: (city: string) => void;
};

export function HomeCityField(props: Props) {
  return (
    <label class="field home-city-field">
      <span>Home city</span>
      <select
        value={(props.value ?? "").toLowerCase()}
        disabled={props.disabled}
        aria-label="Home city"
        onChange={(e) => props.onChange(e.currentTarget.value)}
      >
        <option value="">Not set — sorts all cities equally</option>
        <For each={MEETUP_CITIES}>{(city) => <option value={city.toLowerCase()}>{city}</option>}</For>
      </select>
      <Show when={props.hint}>
        <p class="field-hint">{props.hint}</p>
      </Show>
    </label>
  );
}
